import React, { useState } from 'react';
import Styles from './CanaisAtendimentoWhatsapp.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CanaisAtendimentoQrcode from '../CanaisAtendimentoQrcode';
import CanaisAtendimentoGolpes from '../CanaisAtendimentoGolpes';

function CanaisAtendimentoWhatsapp({ show }) {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }

  return (
    <>
      <div id="page-whatsapp" className={show ? 'show' : ''}>
        <section>
          <ContainerHome24>
            <CanaisAtendimentoQrcode />
          </ContainerHome24>
          <style jsx>{Styles}</style>
        </section>
        <CanaisAtendimentoGolpes />
      </div>
    </>
  );
}

export default CanaisAtendimentoWhatsapp;
